import React, { useEffect, useState } from "react";
import Modal from "./Modal.tsx";
import Checkbox from "../Forms/Checkbox.js";
import { capitalize } from "../../utils/functions.js";

export const AdministerMedication = ({
  isOpen,
  onClose,
  shift,
  medication,
}) => {
  const [isDomshift, setIsDomshift] = useState(false);
  const [medicationList, setMedicationList] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const submitAdminister = async () => {
    setIsLoading(true);
    try {
      console.log(medicationList);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (shift?.shiftType === "Dom Care" && medication?.length > 0) {
      setIsDomshift(true);
      const callMedList = medication.find((item) => item.name === shift?.call);
      const medList = {
        call: callMedList?.name,
        prescription: callMedList?.prescription.map((item) => {
          return {
            ...item,
            name: item,
            checked: false,
          };
        }),
      };
      setMedicationList(medList);
    } else if (shift?.shiftType !== "Dom Care" && medication?.length > 0) {
      setIsDomshift(false);
      const medList = medication.map((item) => {
        return {
          call: item.name,
          prescription: item.prescription.map((item) => {
            return {
              ...item,
              name: item,
              checked: false,
            };
          }),
        };
      });
      setMedicationList(medList);
    }
  }, [shift, medication]);

  return (
    <Modal
      title="Administer Medication"
      size="md"
      onCancel={onClose}
      isOpen={isOpen}
    >
      {isDomshift && medicationList && (
        <>
          {medicationList?.prescription?.map((item) => (
            <div className="mb-8" key={item.name}>
              <Checkbox
                id={item.name}
                label={item.name}
                value={item.checked}
                onChange={(e) => {
                  const updatedPrescription = medicationList.prescription.map(
                    (prescriptionItem) => {
                      if (prescriptionItem.name === item.name) {
                        return {
                          ...prescriptionItem,
                          checked: e.target.checked,
                        };
                      }
                      return prescriptionItem;
                    }
                  );
                  setMedicationList({
                    ...medicationList,
                    prescription: updatedPrescription,
                  });
                }}
              />
            </div>
          ))}
          <button
            type="submit"
            className="btn btn__primary btn--block"
            disabled={isLoading}
            onClick={submitAdminister}
          >
            {isLoading ? "Loading" : "Submit"}
          </button>
        </>
      )}

      {!isDomshift && medicationList && medicationList.length > 0 && (
        <>
          <div className="mb-24">
            {medicationList.map((item) => (
              <div key={item.call}>
                <div className="mb-8">
                  <h5>{capitalize(item.call)}</h5>
                </div>

                {item?.prescription?.map((med) => (
                  <div className="mb-8" key={med.name}>
                    <Checkbox
                      id={item.call + med.name}
                      label={med.name}
                      value={med.checked}
                      onChange={(e) => {
                        const updatedPrescription = item.prescription.map(
                          (prescriptionItem) => {
                            if (prescriptionItem.name === med.name) {
                              return {
                                ...prescriptionItem,
                                checked: e.target.checked,
                              };
                            }
                            return prescriptionItem;
                          }
                        );

                        setMedicationList(
                          medicationList.map((listItem) => {
                            if (listItem.call === item.call) {
                              return {
                                ...listItem,
                                prescription: updatedPrescription,
                              };
                            }
                            return listItem;
                          })
                        );
                      }}
                    />
                  </div>
                ))}
              </div>
            ))}
          </div>

          <button
            type="submit"
            className="btn btn__primary btn--block"
            disabled={isLoading}
            onClick={submitAdminister}
          >
            {isLoading ? "Loading" : "Submit"}
          </button>
        </>
      )}
    </Modal>
  );
};
